export type RunScope = {
  startOn: string;
  endOn: string;
  companyId: string;
};

export type RunIdentity = {
  /** run ごとに 1 つ増える。多重起動と stale callback の判定に使う */
  generation: number;
  /** run を開始した時点の scope。generation だけでは取り逃がすため併せて照合する */
  scope: RunScope;
};

/**
 * 2 つの run が同一かを判定する。
 *
 * Why not generation だけを見る: scope が変わっても generation は増えないので、
 * 「同じ run の途中で日付や会社が変わった」を検出できない（設計書 :313）。
 * useDispatchDetailActions.ts:372 / :387 の isSameTarget と同じ二重照合。
 */
export function isSameRun(a: RunIdentity | null, b: RunIdentity | null): boolean {
  if (a === null || b === null) return false;
  return a.generation === b.generation
    && a.scope.startOn === b.scope.startOn
    && a.scope.endOn === b.scope.endOn
    && a.scope.companyId === b.scope.companyId;
}
